import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { AuthService } from '@account-users/auth/auth.service';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import {
  IMigration,
  IAccountMigration,
  MigrationState,
  IMigrationStatus,
} from '@shared';

@Injectable({
  providedIn: 'root',
})
export class MigrationsService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject('proSyncBaseUrl') private proSyncBaseUrl: string,
  ) {}

  fetchAccountMigrations(accountId: string) {
    return this.http.get(
      `${this.proSyncBaseUrl}account/${accountId}/migrations`,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.accessToken,
        }),
      },
    ) as Observable<IMigration[]>;
  }

  fetchMigrations() {
    return this.http.get(`${this.proSyncBaseUrl}accounts/migrations`, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.authService.accessToken,
      }),
    }) as Observable<IMigration[]>;
  }

  fetchAccountPASMigration(accountId: string) {
    return this.http.get(
      `${this.proSyncBaseUrl}account/${accountId}/migrations`,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.accessToken,
        }),
      },
    ) as Observable<IMigration[]>;
  }

  getAccountMigrations(accountId, startDate) {
    const endDate = moment().format('YYYY-MM-DDThh:mm:ssZ');
    return this.http.get(
      `${this.proSyncBaseUrl}accounts/migrations/orders?from=${startDate}&to=${endDate}&accountId=${accountId}`,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.accessToken,
        }),
      },
    ) as Observable<IAccountMigration[]>;
  }

  getMigrationReport({ oneAccountId, proAccountId, sectionId }: IMigration) {
    return this.http.get(
      `${this.proSyncBaseUrl}account/${oneAccountId}/migrations/logs/${proAccountId}/${sectionId}`,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.accessToken,
        }),
      },
    ) as Observable<{ url: string }>;
  }

  getMigrationProgress({ oneAccountId, proAccountId, sectionId }: IMigration) {
    return this.http.get(
      `${this.proSyncBaseUrl}account/${oneAccountId}/migrations/${proAccountId}/${sectionId}/status`,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.accessToken,
        }),
      },
    ) as Observable<IMigrationStatus>;
  }

  getMigrationStateClass(state: MigrationState) {
    switch (state) {
      case MigrationState.Failed:
        return 'danger';
      case MigrationState.Success:
        return 'success';
      case MigrationState.Pending:
        return 'warning';
      case MigrationState.InProgress:
      case MigrationState.Running:
      case MigrationState.Submitted:
        return 'primary';
      case MigrationState.Paused:
        return 'dark';
      default:
        return '';
    }
  }
}
